export enum ValuationMode {
  intrinsic = 'intrinsic',
  performance = 'performance',
  practitioners = 'practitioners'
}
